const zIndices = {
  summary: 100,
  filters: 1070,
  searchBar: 1071,
  timePicker: 1071,
  headerSubMenuContent: 1072,
  modal: 1120,
};

export type ZIndices = typeof zIndices;

export default zIndices;
